





























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class SearchText extends Vue {
  @Prop({}) filter!: any;

  @Prop({ default: "" }) type!: string;

  @Prop({ default: "" }) customLabel!: string;

  @Prop() model!: any;

  _model: any = "";

  get label() {
    if (this.customLabel) {
      return this.customLabel;
    }
    return this.$t(this.filter.field);
  }

  created() {
    if (this.filter.defaultValue) {
      this._model = this.filter.defaultValue;
      this.$emit("update:model", this.filter.defaultValue);
    } else {
      this._model = this.model ?? "";
    }
  }

  handleChange(event: any) {
    let value = event.target.value as string;

    if (this.filter.regex) {
      value = this.applyRegExpToValue(this.filter.regex, value);
      event.target.value = value;
    }

    this._model = value;
    this.$emit("update:model", value);
  }

  applyRegExpToValue(regex: string, value: string) {
    const match = value.match(regex);
    if (match) {
      return match[0];
    }
    return value;
  }

  checkConstraints(event: KeyboardEvent) {
    if (!this.type) return true;

    const charCode = (event as any).charCode;

    if (
      this.type === "int" ||
      this.type === "unsigned_int" ||
      this.type === "float"
    ) {
      if (charCode >= 48 && charCode <= 57) return true;

      if (this.type === "int" || this.type === "float") {
        if (charCode === 45) return true;
        if (this.type === "float" && charCode === 46) return true;
      }

      event.preventDefault();
    }

    return true;
  }

  @Watch("model")
  onModelChange(newVal: any) {
    this._model = newVal ?? "";
  }
}
